import styled from 'styled-components';

const HiddenSeoH1 = styled.h1`
  text-indent: -9999999px;
  position: absolute;
`;

export default HiddenSeoH1;
